import { api } from './api';

// Converte chave VAPID pública (Base64URL) em Uint8Array — exigido por
// pushManager.subscribe.
export function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = window.atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; ++i) out[i] = raw.charCodeAt(i);
  return out;
}

export function pushSuportado() {
  return 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
}

export async function obterRegistroSW() {
  if (!('serviceWorker' in navigator)) return null;
  // O index.js registra /sw.js no load. `ready` espera a ativação.
  return navigator.serviceWorker.ready;
}

export async function statusPush() {
  if (!pushSuportado()) return { suportado: false, ativo: false, permissao: 'unsupported' };
  const permissao = Notification.permission;
  try {
    const reg = await obterRegistroSW();
    const sub = await reg.pushManager.getSubscription();
    return { suportado: true, ativo: !!sub, permissao, subscription: sub };
  } catch {
    return { suportado: true, ativo: false, permissao };
  }
}

export async function ativarPush() {
  if (!pushSuportado()) throw new Error('Push não suportado neste navegador');

  const perm = await Notification.requestPermission();
  if (perm !== 'granted') throw new Error('Permissão de notificações negada');

  const { data: keyResp } = await api.get('/notifications/vapid-public-key');
  if (!keyResp?.key) throw new Error('Chave VAPID não disponível no servidor');

  const reg = await obterRegistroSW();
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(keyResp.key),
    });
  }

  await api.post('/notifications/subscribe', sub.toJSON());
  return sub;
}

export async function desativarPush() {
  const reg = await obterRegistroSW();
  if (!reg) return;
  const sub = await reg.pushManager.getSubscription();
  if (sub) {
    const endpoint = sub.endpoint;
    try { await sub.unsubscribe(); } catch { /* ignore */ }
    try { await api.delete('/notifications/subscribe', { data: { endpoint } }); } catch { /* ignore */ }
  }
}
